import React from "react";
import { Edit, Identifier } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { FleetManagerForm } from "./FleetManagerForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { FormToolbar } from "../../common/form/FormToolbar";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useAppData } from "../../../common/hooks/useAppData";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IFleetManagerCreateProps {}

export const FleetManagerEdit = (props: IFleetManagerCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  const permissions = useActionPermissions();
  const roles =
    useAppData((x) => x.roles)?.map((x) => ({ id: x.name, name: x.name })) ??
    [];
  const groups = useAppData((x) => x.groups) ?? [];
  const fieldPermissions = useFieldPermissions(
    protectedEntities.FleetManager,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        transform={(record) => {
          record.fleetManagerName = record.name + " " + record.surname;
          if (record.groupIds && !record.groups) {
            record.groups = record.groupIds.map(
              (x: Identifier) => groups.find((g) => g.id === x)!.name!
            );
          }

          if (record.roleId && !record.role) {
            record.role = roles.find((x) => x.id === record.roleId)?.name;
          }

          return record;
        }}
        mutationMode="pessimistic"
        onSuccess={notify}
        title="resources.admin-fleet-managers.title.edit">
        <FleetManagerForm
          isEdit
          toolbar={
            <FormToolbar
              showDeleteButton={
                permissions &&
                permissions[permissionNames.admin.fleetManagers.main] &&
                permissions[permissionNames.admin.fleetManagers.delete]
              }
            />
          }
        />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
